(function () {
  /* rb-pdp-purchase-freq-v1 — show Frequency dropdown on Subscribe */

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.T4Sconfigs && T4Sconfigs.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantId(form) {
    var select = form.querySelector('[name="id"]');
    if (select && select.value) return select.value;

    var checked = form.querySelector('[name="id"]:checked');
    return checked ? checked.value : null;
  }

  function toggleSubscribeMessage(show) {
    document.querySelectorAll('.sbs_message').forEach(function (el) {
      el.style.display = show ? 'block' : 'none';
    });
  }

  function initSubscribe(root) {
    if (!root || root.getAttribute('data-rb-sub-inited') === '1') return;
    var form = root.closest('form[action*="/cart/add"]');
    var jsonEl = root.querySelector('[data-rb-subscribe-json]');
    var data = null;

    try {
      data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (err) {
      data = null;
    }

    root.setAttribute('data-rb-sub-inited', '1');

    var planInput = root.querySelector('[data-rb-selling-plan]');
    var freqWrap = root.querySelector('[data-rb-freq]');
    var freqSelect = root.querySelector('[data-rb-freq-select]');
    var onetimePriceEl = root.querySelector('[data-rb-onetime-price]');
    var subscribePriceEl = root.querySelector('[data-rb-subscribe-price]');
    var discountEl = root.querySelector('[data-rb-subscribe-label]');
    var options = root.querySelectorAll('.rb-pdp-purchase__option');
    var radios = root.querySelectorAll('.rb-pdp-purchase__input');

    function setActiveOption(option) {
      options.forEach(function (el) {
        el.classList.toggle('is-active', el === option);
      });
    }

    function updatePrices(variantId) {
      if (!data || !data.variants) return;
      var prices = data.variants[variantId];
      if (!prices) return;

      var pct = data.discountPct || 0;
      var sub = prices.subscribe;
      if ((!sub || sub >= prices.onetime) && pct > 0) {
        sub = Math.round((prices.onetime * (100 - pct)) / 100);
      }
      if (prices.onetime > sub && prices.onetime > 0) {
        pct = Math.round(((prices.onetime - sub) * 100) / prices.onetime);
      }

      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(prices.onetime);
      if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(sub);

      if (discountEl) {
        discountEl.textContent = 'Subscribe & save ' + (pct > 0 ? pct : 20) + '%';
      }
    }

    function selectedPlanId() {
      if (freqSelect && freqSelect.value) return freqSelect.value;
      return data && data.defaultPlanId ? data.defaultPlanId : '';
    }

    function setPurchaseType(type) {
      var isSubscribe = type === 'subscribe';

      root.classList.toggle('is-subscribe', isSubscribe);
      if (freqWrap) freqWrap.hidden = !isSubscribe;

      if (planInput) {
        if (isSubscribe) {
          planInput.disabled = false;
          planInput.value = selectedPlanId();
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      toggleSubscribeMessage(isSubscribe);
    }

    function selectOption(option) {
      var radio = option && option.querySelector('.rb-pdp-purchase__input');
      if (!radio) return;
      radios.forEach(function (el) {
        el.checked = el === radio;
      });
      setActiveOption(option);
      setPurchaseType(radio.value);
    }

    options.forEach(function (option) {
      option.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectOption(option);
        },
        true
      );
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        setActiveOption(radio.closest('.rb-pdp-purchase__option'));
        setPurchaseType(radio.value);
      });
    });

    if (freqSelect) {
      freqSelect.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      freqSelect.addEventListener('change', function () {
        if (!planInput || planInput.disabled) return;
        planInput.value = freqSelect.value;
      });
    }

    if (form) {
      var variantField = form.querySelector('[name="id"]');
      if (variantField) {
        variantField.addEventListener('change', function () {
          updatePrices(getVariantId(form));
        });
      }

      document.addEventListener('change', function (event) {
        if (!form.contains(event.target)) return;
        if (event.target.matches('[data-swatch-item]')) {
          setTimeout(function () {
            updatePrices(getVariantId(form));
          }, 0);
        }
      });

      updatePrices(getVariantId(form));
    }

    var checked = root.querySelector('.rb-pdp-purchase__input:checked');
    setPurchaseType(checked ? checked.value : 'onetime');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rb-subscribe]').forEach(initSubscribe);
  }

  window.rbInitProductSubscribe = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
